const insertRow = ({ object, items }) => [
  {
    ...object,
    amendmentTotal: 0,
  },
  ...items
];

export default insertRow;
